import { render } from "./PractitionerList.vue?vue&type=template&id=3342efe4"
import script from "./PractitionerList.vue?vue&type=script&lang=js"
export * from "./PractitionerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__